import randysWorldwideDefaults from '../randys-worldwide/config.js';
import { initHelpers } from '../randys-worldwide/helpers.js';

initHelpers({ YMMTabSelector: 'tab-btn1' });

// the Towing Hitches collection is sorted by Best Sellers, other pages keep the default sort
const isTowingHitchesCollectionPage = window.location.pathname === '/collections/towing-hitches';

export default {
  ...randysWorldwideDefaults,
  includes: ['shopify-generic', 'randys-worldwide'],
  SearchRequestDefaults: {
    ...randysWorldwideDefaults.SearchRequestDefaults,
    ...(isTowingHitchesCollectionPage ? { sort: 'order_count:desc' } : {}),
  },
};
